import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getModelsByBrand = (brandId) => {
  const url = `${API_URL}/api/v1/brand/${brandId}/model`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al obtener modelos';
        dispatch(setGetModels(outputData));
      } else {
        outputData['data'] = data.data;
        outputData['message'] = data.message;
        dispatch(setGetModels(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetModels({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetModels = (data) => ({
  type: types.bmGetModels,
  payload: data,
});

export const createModel = (brandId, name) => {
  const url = `${API_URL}/api/v1/brand/${brandId}/model/create`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.post(url, { name }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setCreateModel(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setCreateModel(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setCreateModel({ status: 'danger', error: true, message }));
      });
  };
};

export const setCreateModel = (data) => ({
  type: types.bmCreateModel,
  payload: data,
});

export const updateModel = (modelId, name) => {
  const url = `${API_URL}/api/v1/model/edit/${modelId}`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.put(url, { name }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setUpdateModel(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setUpdateModel(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setUpdateModel({ status: 'danger', error: true, message }));
      });
  };
};

export const setUpdateModel = (data) => ({
  type: types.bmUpdateModel,
  payload: data,
});

export const deleteModelById = (modelId) => {
  const url = `${API_URL}/api/v1/model/${modelId}`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.delete(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteModelById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setDeleteModelById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteModelById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteModelById = (data) => ({
  type: types.bmDeleteModelById,
  payload: data,
});
